import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoFormacoesDisciplina.vue?vue&type=template&id=4da5a684&scoped=true"
import script from "./RelatorioSinteticoAnaliticoFormacoesDisciplina.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoFormacoesDisciplina.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSinteticoAnaliticoFormacoesDisciplina.vue?vue&type=style&index=0&id=4da5a684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da5a684",
  null
  
)

export default component.exports